import React, { useState } from 'react';
import axios from '../api/api';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

const ContactForm = () => {
    const [validated, setValidated] = useState<boolean>(false);
    const [email, setEmail] = useState<string>('');
    const [message, setMessage] = useState<string>('');
    const [privacyPolicyAgreement, setPrivacyPolicyAgreement] = useState<boolean>(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return;
        }

        try {
            await axios.post('/send-mail', {
                email,
                message,
                privacyPolicyAgreement,
            });
            setEmail('');
            setMessage('');
            setPrivacyPolicyAgreement(false);
            setValidated(false);
            console.log('Email sent successfully');
        } catch (error) {
            console.error('Error sending email:', error);
        }
    };

    return (
        <Form noValidate validated={validated} onSubmit={handleSubmit} className='contact__form-col__form'>
            <Row className="mb-3" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <h2 className="my-5">Contact</h2>
                <h5 style={{ fontSize: '16px', lineHeight: '1.5' }}>
                    Send an email to <a style={{ color: "#6F6B8F", textDecoration: 'none' }} href="mailto:support@mindfield-creations.com">admin@mindfield-creations.com</a> <br />or complete the form below
                </h5>
                <Form.Group as={Col} md="4" style={{ width: '100%' }} controlId="validationCustom01" className="contact-form__content__group my-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        required
                        type="email"
                        placeholder="your-email@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid">
                        Please choose an email.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4" style={{ width: '100%' }} className="contact-form__content__group my-3 contact-form__content__group" controlId="validationCustom02">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                        as="textarea"
                        aria-label="With textarea"
                        required
                        className="contact__form-col__form__text-area"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                    <Form.Control.Feedback type="invalid" style={{ fontSize: '16px' }}>
                        Please type a message.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="my-1 contact-form__content__group">
                    <Form.Check
                        required
                        label="Agree to our friendly privacy policy"
                        feedbackType="invalid"
                        checked={privacyPolicyAgreement}
                        onChange={(e) => setPrivacyPolicyAgreement(e.target.checked)}
                    />
                </Form.Group>
            </Row>
            <Button type="submit" className="contact__form-col__form__button">Send Message</Button>
        </Form>
    );
}

export default ContactForm;